var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMultiDayTour(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.25 3.75C8.25 3.33579 8.58579 3 9 3H14.3036C14.5588 3 14.7965 3.12976 14.9345 3.34443L16.3809 5.59443C16.5397 5.84149 16.5397 6.15851 16.3809 6.40557L14.9345 8.65557C14.7965 8.87023 14.5588 9 14.3036 9H9.75V15.75C9.75 16.1642 9.41421 16.5 9 16.5C8.58579 16.5 8.25 16.1642 8.25 15.75V11.25H3.69643C3.44123 11.25 3.20354 11.1202 3.06554 10.9056L1.61912 8.65557C1.46029 8.40851 1.46029 8.09149 1.61912 7.84443L3.06554 5.59443C3.20354 5.37976 3.44123 5.25 3.69643 5.25H8.25V3.75ZM9.75 7.5H13.8941L14.8584 6L13.8941 4.5H9.75V7.5ZM8.25 6.75H4.10589L3.14161 8.25L4.10589 9.75H8.25V6.75Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 15.75C7.5 16.1642 7.16421 16.5 6.75 16.5C6.33579 16.5 6 16.1642 6 15.75C6 15.3358 6.33579 15 6.75 15C7.16421 15 7.5 15.3358 7.5 15.75Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.5 15.75C3.5 16.1642 3.16421 16.5 2.75 16.5C2.33579 16.5 2 16.1642 2 15.75C2 15.3358 2.33579 15 2.75 15C3.16421 15 3.5 15.3358 3.5 15.75Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMultiDayTour);
export default __webpack_public_path__ + "static/media/multi-day-tour.fb97d289.svg";
export { ForwardRef as ReactComponent };